<template>
	<div class="app-topic app-topic--brend">
		<div class="app-topic__header">
			<template v-if="recommended">
				<h1 class="app-topic__title">
					<template v-if="current_company === 'megafon'">
						{{ $t('recommended_megafon_plan') }}
					</template>
					<template v-else>
						{{ $t('recommended_programms') }}
					</template>
					<span class="flag flag--bg-white ml-5">{{ selection.length }}</span>
				</h1>
			</template>
			<template v-else>
				<h1 class="app-topic__title">
					<template v-if="current_company === 'megafon'">
						{{ $t('megafon_plan') }}
					</template>
					<template v-else>
						{{ $t('learning_plan') }}
					</template>
					<span class="flag flag--bg-white ml-5">{{ selection.length }}</span>
				</h1>
			</template>
		</div>

		<div class="app-topic__results">
			<template v-if="selection">
				<ul class="app-topic__list">
					<li
						v-for="(prescription, index) in selection"
						:key="'section-' + prescription.id + '-' + index"
					>
						<PlanPreview
							:prescription="prescription"
							:currentCompany="current_company"
							:recommended="recommended"
						/>
					</li>
				</ul>
			</template>
			<template v-else>
				<div class="app-topic__message-holder">
					<template v-if="recommended">
						<div v-if="current_company === 'megafon'" class="app-plan__message-holder">
							<p class="app-topic__message-top">{{ $t('messages.recommended_megafon_1') }}</p>
							<p class="app-topic__message-bottom">{{ $t('messages.recommended_megafon_2') }}</p>
						</div>
						<div v-else class="app-topic__message-holder">
							<p class="app-topic__message-top">{{ $t('messages.no_recommended_training') }}</p>
							<p class="app-topic__message-bottom">{{ $t('messages.choose_description') }}</p>
						</div>
					</template>
					<template v-else>
						<div v-if="current_company === 'megafon'" class="app-topic__message-holder">
							<p class="app-topic__message-top">{{ $t('messages.megafon_1') }}</p>
							<p class="app-topic__message-bottom">{{ $t('messages.megafon_2') }}</p>
						</div>
						<div v-else class="app-topic__message-holder">
							<p class="app-topic__message-top">{{ $t('messages.no_training') }}</p>
							<p class="app-topic__message-bottom">{{ $t('messages.choose_description') }}</p>
						</div>
					</template>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import PlanPreview from "./PlanPreview.vue";

export default {
	name: "PlanTopic",

	components: {
		PlanPreview
	},

	props: {
		selection: Array,
		learning_plan_result: String,
		newCourses: {
			type: Boolean,
			default: false,
		},
		current_company: {
			type: String,
			default: ''
		},
		recommended: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
		};
	},

	methods: {
		generateRandomNamber(limit) {
			return Math.floor(Math.random() * limit) + 1;
		},
	}
}
</script>

